import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  max-width: 840px;
  padding: 20px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  width: 100%;
  .ant-collapse .ant-collapse-content {
    background-color: ${({ theme }) => theme.colors.black1};
  }

  .ant-collapse .ant-collapse-header {
    background-color: ${({ theme }) => theme.colors.black1};
  }
`;
export const FormulaWrapper = styled.div`
  display: flex;
`;

export const StyledImage = styled.img`
  width: fit-content;
  max-width: 100%;
`;

export const IndexAnswer = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const QuestionTitle = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  flex-grow: 1;
`;

export const SectionName = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: space-between;
`;
